import { CButton, CFormLabel, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import Select from 'react-select'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
import { useIndexedDB } from '../../context/IndexedContext'
const AddDiagnosisModal = ({
  patientDiagnosis,
  saveTreatsShell,
  patientID,
  setPatientData,
  loggedUserProvider,
  patientData,
  setDiagnosisAddedPinger,
  showOnlyNoteDiagnosis,
  handleToggleAddDiagnosis,
  addDiagnosisIdsToNote,
  saveDiagnosisData,
  setAddDiagnosisModalVisible,
  addDiagnosisModalVisible,
  getPatientDiagnosis,
  noteCallType,
}) => {
  const { getOfflineData, saveOfflineData, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()
  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])

  const [diagnosisData, setDiagnosisData] = useState([])

  useEffect(() => {
    if (patientDiagnosis?.length && diagnosisData?.length) {
      const filtered = diagnosisData.filter((item) => patientDiagnosis.includes(item.label))
      setAllSelectedDiagnosis(filtered)
    }
  }, [diagnosisData, patientDiagnosis, addDiagnosisModalVisible])

  const { getAllMasterDiagnosis } = useIndexedDB()
  useEffect(() => {
    const fetchDiagnosisDatabase = async () => {
      const getAllMasterDiagnosisOption = await getAllMasterDiagnosis()
      let options = []
      getAllMasterDiagnosisOption.Data.map((obj) => {
        options.push({
          value: obj.id,
          label: obj.Name.trim(),
        })
      })
      setDiagnosisData(options)
    }
    fetchDiagnosisDatabase()
  }, [])

  // const getData = async () => {
  //   let a = await GetDiagnosisData();
  //   let data = JSON.parse(a.d);
  //   let options = [];
  //   data.Data.map(obj => {
  //     options.push({
  //       value: obj.id,
  //       label: obj.Name.trim()
  //     });
  //   });
  //   setDiagnosisData(options);
  //   ;
  // }

  // useEffect(() => {
  //   getData()
  // }, [])

  const [isAddingDiagnosis, setIsAddingDiagnosis] = useState(false)

  const handleAddDiagnosisOffline = async (combinedDiagnosis) => {
    let dataOffline = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    if (dataOffline) {
      dataOffline = {
        ...dataOffline,
        [loggedUserProvider?.ID]: {
          ...dataOffline[loggedUserProvider?.ID],
          [patientID]: {
            ...dataOffline[loggedUserProvider?.ID][patientID],
            patientData: {
              ...dataOffline[loggedUserProvider?.ID][patientID]?.patientData,
              Diagnosis: combinedDiagnosis,
            },
            finalDiagnosis: combinedDiagnosis,
            saveDraft: true,
          },
        },
      }
      setPatientData((p) => ({
        ...p,
        Diagnosis: combinedDiagnosis,
      }))
      // await saveOfflineData(dataOffline)
      noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(dataOffline) : await saveOfflineData(dataOffline)
    }
  }

  const handleSubmit = async () => {
    try {
      setIsAddingDiagnosis(true)
      const newSelectedLabels = allSelectedDiagnosis.map((item) => item.label)
      const allSelectedDiagnosisIds = allSelectedDiagnosis.map((item) => item.value)
      const existing = Array.isArray(patientDiagnosis) ? patientDiagnosis : patientDiagnosis?.split(',')?.filter(Boolean) || []

      const combinedDiagnosis = Array.from(new Set([...existing, ...newSelectedLabels]))
        .filter(Boolean)
        .join(',')

      // await ModifyPatientMap("UPDATE", patientID, combinedDiagnosis);
      await handleAddDiagnosisOffline(combinedDiagnosis)
      await addDiagnosisIdsToNote(allSelectedDiagnosisIds)

      // handleToggleAddDiagnosis();
      setAllSelectedDiagnosis([])
      // saveDiagnosisData({
      //   ...patientData,
      //   Diagnosis: combinedDiagnosis,
      // })
      setAddDiagnosisModalVisible(false)
      await getPatientDiagnosis()
      setDiagnosisAddedPinger((prev) => !prev)
      await showOnlyNoteDiagnosis()
      await saveTreatsShell(false)
      setIsAddingDiagnosis(false)
    } catch (error) {
      console.log(error)
      setIsAddingDiagnosis(false)
    }
  }

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  return (
    <>
      {role === 'provider' ? (
        <CModal size="md" backdrop="static" alignment="center" aria-labelledby="VerticallyCenteredExample" visible={addDiagnosisModalVisible} onClose={() => setAddDiagnosisModalVisible(false)}>
          <CModalHeader
            style={{
              backgroundColor: '#282828',
              borderBottom: '1px solid gray',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              borderRadius: '10px 10px 0 0',
            }}
          >
            <CModalTitle
              style={{
                color: 'white',
                textAlign: 'center',
                width: '100%',
                fontWeight: '200',
              }}
            >
              Add Diagnosis
            </CModalTitle>
          </CModalHeader>
          <CModalBody
            style={{
              backgroundColor: '#282828',
              color: 'white',
            }}
          >
            <div>
              <div className="m-3">
                <CFormLabel>Select Diagnosis</CFormLabel>
                <Select
                  closeMenuOnSelect={false}
                  closeMenuOnScroll={false}
                  placeholder="Select"
                  isMulti
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: '#191919',
                      borderColor: state.isFocused ? '#444' : '#444',
                      borderRadius: '6px',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#444',
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      backgroundColor: '#000',
                      borderRadius: '6px',
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#191919' // blue for selected
                        : state.isFocused
                          ? '#2a2a2a'
                          : '#000',
                      color: 'white',
                      cursor: 'pointer',
                      padding: '12px 14px',
                      borderBottom: '1px solid #333',
                      ':last-of-type': {
                        borderBottom: 'none',
                      },
                      ':active': {
                        backgroundColor: '#2a2a2a',
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: '#191919',
                      borderRadius: '4px',
                      border: '1px solid #454545ff',
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: 'white',
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: 'white',
                      ':hover': {
                        backgroundColor: '#333',
                        color: 'white',
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: 'white',
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#aaa',
                    }),

                    input: (base) => ({
                      ...base,
                      color: 'white',
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      color: 'white',
                      ':hover': { color: 'white' },
                    }),
                  }}
                  name="diagnosis"
                  value={allSelectedDiagnosis}
                  onChange={(e) => {
                    setAllSelectedDiagnosis([...e])
                  }}
                  options={diagnosisData.sort((a, b) => a.label.localeCompare(b.label))}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
            </div>
          </CModalBody>

          <CModalFooter
            style={{
              backgroundColor: '#282828',
              borderTop: '1px solid gray',
              display: 'flex',
              justifyContent: 'center',
              gap: '10px',
              paddingTop: '10px',
            }}
          >
            <CButton
              onClick={() => {
                setAddDiagnosisModalVisible(false)
                setAllSelectedDiagnosis([])
              }}
              className=" "
              style={{
                backgroundColor: 'transparent',
                border: '1px solid #737373',
                color: '#E0E0E0',
                borderRadius: '6px',
                padding: '8px 20px',
              }}
              variant="outline"
              color="secondary"
            >
              {' '}
              Cancel
            </CButton>
            <CButton
              style={{
                backgroundColor: '#4363F2',
                border: 'none',
                color: 'white',
                borderRadius: '6px',
                padding: '8px 20px',
              }}
              onClick={handleSubmit}
              color="primary"
            >
              Add Diagnosis 
            </CButton>
          </CModalFooter>
        </CModal>
      ) : (
        <CModal size="md" backdrop="static" alignment="center" aria-labelledby="VerticallyCenteredExample" visible={addDiagnosisModalVisible} onClose={() => setAddDiagnosisModalVisible(false)}>
          <CModalHeader>
            <CModalTitle>Add Diagnosis</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div>
              <div className="m-3">
                <CFormLabel>Select Diagnosis</CFormLabel>
                <Select
                  closeMenuOnSelect={false}
                  closeMenuOnScroll={false}
                  placeholder="Select"
                  isMulti
                  name="diagnosis"
                  value={allSelectedDiagnosis}
                  onChange={(e) => {
                    setAllSelectedDiagnosis([...e])
                  }}
                  options={diagnosisData.sort((a, b) => a.label.localeCompare(b.label))}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
            </div>
          </CModalBody>

          <CModalFooter>
            <CButton
              onClick={() => {
                setAddDiagnosisModalVisible(false)
                setAllSelectedDiagnosis([])
              }}
              color="secondary"
              variant="outline"
            >
              Cancel
            </CButton>
            <CButton onClick={handleSubmit} color="primary" disabled={isAddingDiagnosis}>
              {isAddingDiagnosis ? <CSpinner component="span" size="sm" aria-hidden="true" /> : 'Add Diagnosis'}
            </CButton>
          </CModalFooter>
        </CModal>
      )}
    </>
  )
}

export default AddDiagnosisModal
